import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogoMCPIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogoMCP",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M29.003 7.99h.01l-.07-.07a5.74 5.74 0 0 0-4.811-1.57 5.5 5.5 0 0 0-1.61-4.722 5.756 5.756 0 0 0-8.023 0L1.665 14.222l-.02.02c-.42.43-.41 1.13.02 1.55.45.43 1.16.43 1.6 0L16.1 3.198a3.455 3.455 0 0 1 4.812 0l.06.06a3.3 3.3 0 0 1-.05 4.662l-9.703 9.513-.02.02c-.42.43-.41 1.13.02 1.55.45.43 1.16.43 1.61 0l.13-.13 9.563-9.383a3.455 3.455 0 0 1 4.812 0l.07.07.06.06a3.3 3.3 0 0 1-.06 4.662L15.789 25.665l-.05.05a2.526 2.526 0 0 0 .015 3.588l2.416 2.374c.45.43 1.16.43 1.6 0l.02-.02c.42-.43.41-1.13-.02-1.55l-2.38-2.34a.374.374 0 0 1 0-.521l11.613-11.384.11-.11a5.495 5.495 0 0 0-.11-7.762"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "m25.722 12.641.01-.01c.43-.42.44-1.12.02-1.55l-.02-.02c-.45-.43-1.16-.43-1.61 0l-9.493 9.313a3.455 3.455 0 0 1-4.812 0 3.3 3.3 0 0 1-.06-4.662l.06-.06L19.31 6.34c.43-.42.44-1.12.02-1.55l-.02-.02c-.45-.43-1.16-.43-1.61 0l-9.493 9.313a5.494 5.494 0 0 0-.11 7.762l.11.11a5.755 5.755 0 0 0 8.022 0z"
    })]
  }));
};
LogoMCPIcon.displayName = 'LogoMCPIcon';